import { Component, inject, signal } from '@angular/core';
import { form, submit } from '@angular/forms/signals';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { ProjectBasicInformationComponent } from '@app/components/company/company-projects/company-project-basic-information/project-basic-information.component';
import {
  CreateProjectModel,
  projectFormSchema
} from '@app/components/company/company-projects/create-project-dialog/create-project-form-controls';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { DialogService } from '@app/shared/services/shared/dialog.service';
import { Project } from '@app/shared/types/models/project/project.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { CreateProjectService } from './create-project.service';

@Component({
  selector: 'proffeo-create-project-dialog',
  imports: [
    MatDialogModule,
    TranslatePipe,
    UiDialogComponent,
    MatStepperModule,
    ProjectBasicInformationComponent,
    UiButtonComponent
  ],
  templateUrl: './create-project-dialog.component.html',
  styleUrl: './create-project-dialog.component.scss',
  providers: [CreateProjectService]
})
export class CreateProjectDialogComponent {
  private readonly createProjectService: CreateProjectService = inject(CreateProjectService);
  private readonly dialogRef: MatDialogRef<CreateProjectDialogComponent> = inject(
    MatDialogRef<CreateProjectDialogComponent>
  );
  private readonly dialogService: DialogService = inject(DialogService);

  protected readonly model = signal<CreateProjectModel>(this.createProjectService.createInitialModel());
  protected readonly form = form(this.model, projectFormSchema);

  protected close(): void {
    this.dialogRef.close();
  }

  protected saveProject(): void {
    void submit(this.form, {
      action: async () => {
        await firstValueFrom(this.createProjectService.saveProject(this.model()));
        this.close();
      },
      onInvalid: () => this.form().errorSummary()[0]?.fieldTree().focusBoundControl()
    });
  }

  public goToEditDraftCompanyProject(project: Project): void {
    this.dialogService
      .openEditCompanyProjectDialog(project, true)
      .afterOpened()
      .subscribe(() => this.close());
  }
}
